<template>
  <v-form class="piwiblue" ref="form" v-model="valid" :lazy-validation="lazy">
    <v-layout wrap class="login-form-wrapper">
      <v-flex grow class="m-t-20">
        <v-text-field
          v-validate="'required|email'"
          :error-messages="errors.collect('username')"
          data-vv-name="username"
          :value="value.username"
          ref="username"
          :disabled="loading"
          :label="usernameLabel"
          @change="updateData('username', $event)"
          solo
          flat
          prepend-inner-icon="mdi-account"
          class="username-input"
          required
        ></v-text-field>
      </v-flex>
      <v-flex xs12 class="m-t-5">
        <v-text-field
          v-validate="'required|max:16'"
          :error-messages="errors.collect('password')"
          data-vv-name="password"
          :value="value.password"
          ref="password"
          :disabled="loading"
          :label="passwordLabel"
          type="password"
          @change="updateData('password', $event)"
          solo
          flat
          prepend-inner-icon="mdi-lock"
          required
        ></v-text-field>
      </v-flex>
      <v-flex xs12 class="login-switch-wrapper">
        <v-switch
          v-model="rememberMe"
          :label="rememberMeLabel"
          :disabled="loading"
          @change="remember"
          dark
          color="success"
          class="font-sm"
        ></v-switch>
      </v-flex>
      <v-flex xs12>
        <v-btn block class="black--text gradient-yellow login-btn" @click="submit" :loading="loading">Login</v-btn>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
import { authFormMixin } from '../../mixins/auth-form-mixin'
import storage from '../../utility/storage'

export default {
  name: 'LoginForm',
  mixins: [authFormMixin],
  data () {
    return {
      rememberMe: false
    }
  },
  methods: {
    submit () {
      this.remember()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading = true
          this.$store.dispatch('auth/login', this.value).then(() => {
          this.$emit('logined')
          }).catch(err => {
            this.$emit('failed', err)
          }).finally(() => {
            this.loading = false
          })
          return;
        }
        this.loading = false
      });
    },
    remember() {
      if (this.rememberMe) {
        storage.setObject('remember_me', this.value)
      } else {
        storage.removeItem('remember_me')
      }
    }
  },
  mounted() {
    const remember = storage.getObject('remember_me')
    if (remember) {
      this.rememberMe = true
      this.value.username = remember.username
      this.value.password = remember.password
      this.value.userType = this.userType.affiliate
    }
  },
  props: {
    rememberMeLabel: { type: String, default: 'Remember password' },
    value: {
      type: Object,
      default: function () {
        return { username: '', password: '', userType: '' }
      }
    }
  }
}
</script>

<style scoped>

</style>
